import { computed, observable } from 'mobx';
import { year } from '@/utils/date';

export default class Control {
  @observable year = String(year);

  @computed get isDisabledDate() {
    return {
      disabledDate: (date: Date) => date.getFullYear() !== Number(this.year),
    };
  }
}
